// extracted by mini-css-extract-plugin
export var callOut = "titlebar-landing-module--callOut--603da";
export var callOutButtonContainer = "titlebar-landing-module--callOutButtonContainer--4d295";
export var callOutInner = "titlebar-landing-module--callOutInner--b10ae";
export var calloutTitle = "titlebar-landing-module--calloutTitle--f0bfe";
export var titleBar = "titlebar-landing-module--titleBar--da471";
export var titleBarDesc = "titlebar-landing-module--titleBarDesc--79d85";
export var titleBarNoCallout = "titlebar-landing-module--titleBarNoCallout--b8688";
export var titleBarTitle = "titlebar-landing-module--titleBarTitle--b1e88";
export var titleBarTitleNoCallout = "titlebar-landing-module--titleBarTitleNoCallout--bb603";
export var titleBarTop = "titlebar-landing-module--titleBarTop--0d9a7";